import React  from "react";
import styles from "../tiles.module.scss";
import Chevron from "../../../../components/chevron/Chevron";
import * as utils from '../../../../utils/utils';
import CXBarChartSm from '../../../../components/chart-sm/Chart-sm';
//import { ConsoleView } from "react-device-detect";
//import { CreateScoreLinks } from '../../../score/Score.utils';

const KPIScore = (props) => {
    const { kpi, kpiIndex,selectedProductDivision, selectedSBS, selectedCustomer } = props; 
      let isProductDivision = false;
    if(Object.keys(selectedProductDivision).length !== 0 && Object.keys(selectedSBS).length === 0 && Object.keys(selectedCustomer).length === 0){
     isProductDivision = true;
    } 

     const kpiItem = kpi.find((item) => item.id === kpiIndex)

    const {id, name, score, lastQuarterValue, kpiKeys, kpiValues, dataPoints} = kpiItem
    console.log("My KPI-- props*------",props);
    console.log("My KPI-- New KPI Item*------",kpiItem);
    console.log("My KPI keys and values",kpiKeys, kpiValues);

    const getKPITileNames = (kpiName) =>{
        let tileName;
        let kpi = kpiName.split(" ").join("").toLowerCase();
        switch(kpi){
            case 'ardisputeresolutionindex': tileName = 'AR Dispute Index';
            break;
            case 'availabilityindex': tileName = 'Availability Index';
            break;
            case 'heldorderindex': tileName = 'Held Order Index';
            break;
            case 'invoicingindex': tileName = 'Invoicing Index';
            break;
            case 'perfectorderindex': tileName = 'Perfect Order Index';
            break;
            case 'totaladmincomplaints': tileName = 'Admin Complaints';
            break;
            default: break;
        }  

        return tileName;
    }
    
    return (
        <div
            className={styles.kpiCardContainer}
            onClick={() => props.viewScore('kpi',kpiItem)}
        >
            <div className={styles.kpiCardHeader}>
                { (dataPoints !== undefined)?
                <div className={styles.nValue}>n = { utils.convertToInternationalCurrencySystem(dataPoints)}</div>:''
                }
            </div>
            <div className={styles.kpiCardBody}>
                <div className={styles.cardTitle}>{`${getKPITileNames(name)}`}</div>
                <div className={styles.progressValBody}>
                    {
                        !score ? `-` : <span className={`${styles.progressVal} ${Number(score.toFixed(0))!== Number(lastQuarterValue.toFixed(0))? Number(score.toFixed(0))   >  Number(lastQuarterValue.toFixed(0)) ? 'text-color-green' : 'text-color-red': 'text-color-yellow'}`}>{`${Number(score.toFixed(0))}`}<span className={`${styles.chevron} `}><Chevron className={`accordion__icon ${Number(score.toFixed(0)) < Number(lastQuarterValue.toFixed(0)) ? styles.rotate : null}`} width={13} height={15} fill={"#000"} /></span></span>
                    }
                    
                    <span className={styles.indexDesc}>
                        {
                            Number(score.toFixed(0))-Number(lastQuarterValue.toFixed(0)) ===0 ? <span className={styles.zeroPadding}>{``}</span> : Number(score.toFixed(0)) > Number(lastQuarterValue.toFixed(0)) ?<span>+</span> : <span>-</span>
                        }
                        {
                          <span>{Math.abs(Number(score.toFixed(0)) - Number(lastQuarterValue.toFixed(0)))}</span>  
                        }
                        {/*
                            <span>{`${Math.abs(difference.toFixed(0))}`}</span>
                    */}
                        {/*<span>{Math.abs(Number(cxScore.score).toFixed(0) - Number(cxScore.lastQuarterValue).toFixed(0))}</span>*/}
                                {/*<span className={cxScore.score > cxScore.lastQuarterValue ? styles.arrowUp : styles.arrowDown}></span>*/}
                    </span>
                </div>
                {<div className={isProductDivision? styles.kpiScoreTrendingChartPD: styles.kpiScoreTrendingChart}>
                    <CXBarChartSm 
                                id= {id}
                                height={30}
                                width={60}
                                keys={kpiKeys}
                                values={kpiValues}></CXBarChartSm>
                </div>}
            </div>
        </div>
    )
}
export default KPIScore;